import * as types from "@root/types";
import React, { createContext, FC, ReactNode, useContext } from "react";

export const ArtistsContext = createContext<types.ArtistsContext>({
  artists: [],
});
ArtistsContext.displayName = "ArtistsData";

interface ArtistsProviderProps {
  artists: types.Artist[];
  query?: string;
  children?: ReactNode;
}

export const ArtistsProvider: FC<ArtistsProviderProps> = ({
  artists,
  children,
}) => {
  return (
    <ArtistsContext.Provider value={{ artists }}>
      {children}
    </ArtistsContext.Provider>
  );
};

export const useArtists: () => types.ArtistsContext = () =>
  useContext(ArtistsContext);
